import React, { useState } from 'react';
import SwitchToggle from 'components/Buttons/SwitchToggleGeneral';
import GridBox from 'components/Grid/Grid';
import Row from 'components/Grid/Row';
import BalloonDoubts from 'components/BalloonDoubts';
import DeleteForeverSharpIcon from '@mui/icons-material/DeleteForeverSharp';
import Load from 'components/Load/Load';
import * as S from './styled';

function Toggle({ item, itemToggle, onToggle, onDelete, loadingDelete }) {
	const [activeToggle, setActiveToggle] = useState(itemToggle?.isChecked || false);

	if (loadingDelete) return <Load />;
	return (
		<GridBox>
			<Row>
				<S.Box size={1.6}>
					<SwitchToggle
						isChecked={activeToggle}
						setIsChecked={(isChecked) => {
							setActiveToggle(isChecked);
							onToggle(isChecked);
						}}
					/>
				</S.Box>
				<S.Box size={7.4}>
					<S.title>{item.name} </S.title>
				</S.Box>
				<S.Box size={3}>
					<S.boxIcons>
						<DeleteForeverSharpIcon sx={{ color: 'red', fontSize: 20, cursor: 'pointer' }} onClick={onDelete} />
						<BalloonDoubts item={item} />
					</S.boxIcons>
				</S.Box>
				<S.Box size={12}>
					<S.Line />
				</S.Box>
			</Row>
		</GridBox>
	);
}

export default Toggle;
